import { Injectable, Type } from "@angular/core";

import { BaseLookupService } from "../../impl/BaseLookupService";

import { PromiseLookupService } from "../../impl/PromiseLookupService";

import { IAutoCompleteLabelValuePromiseLookupService } from "../IAutoCompleteLabelValuePromiseLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { AutoCompleteLabelValue } from "../../../model/core/AutoCompleteLabelValue";

export abstract class AutoCompleteLabelValuePromiseLookupService<
    K,
    V extends CubiqTS.ConcreteEncodable,
  >
  extends PromiseLookupService<K, V>
  implements IAutoCompleteLabelValuePromiseLookupService
{
  constructor() {
    super();
  }

  abstract getLabelValueById(opts?: {
    prefix?: String;
    skip?: number;
    limit?: number;
  }): Promise<AutoCompleteLabelValue[]>;
  abstract getLabelValueByName(opts?: {
    prefix?: String;
    skip?: number;
    limit?: number;
  }): Promise<AutoCompleteLabelValue[]>;
}
